import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BlankTemplate from 'components/Templates/BlankTemplate';
import UploadInvestmentProofs from 'components/Organisms/MyPay/UploadProofs';
import useToast from 'components/Provider/useToast';
import { getToastMessage } from 'utils/toastMessage';

const UploadInvestmentProofsTemplate = ({
  formData,
  handleCancel,
  handleUpload,
  employeeDetails,
  handleDelete,
  handleDeleteFile,
  toastSuccessMessage,
  toastErrorMessage,
  showToast,
  toastType,
  handleSubmitProofs,
  userHasProofSubmitPermission,
  userhasProofUploadPermission,
}) => {
  const addToast = useToast();

  useEffect(() => {
    if (showToast) {
      const successMessage = toastSuccessMessage || getToastMessage.UploadInvestmentProofs()[0];
      const error = toastErrorMessage || getToastMessage.UploadInvestmentProofs()[1];

      const title = toastType === 'success' ? 'Success!' : 'Error!';
      const type = toastType === 'success' ? 'success' : 'error';
      const message = toastType === 'success' ? successMessage : error;
      addToast({ type, title, message });
    }
  }, [showToast, toastErrorMessage, toastSuccessMessage, toastType]);

  return (
    <BlankTemplate pageHeading="Upload Investment Proofs" isBreadcrumb={false} padding="2rem 3rem">
      <UploadInvestmentProofs
        formData={formData}
        handleCancel={handleCancel}
        handleUpload={handleUpload}
        employeeDetails={employeeDetails}
        handleDelete={handleDelete}
        handleDeleteFile={handleDeleteFile}
        handleSubmitProofs={handleSubmitProofs}
        userHasProofSubmitPermission={userHasProofSubmitPermission}
        userhasProofUploadPermission={userhasProofUploadPermission}
      />
    </BlankTemplate>
  );
};

UploadInvestmentProofsTemplate.defaultProps = {
  formData: [],
  employeeDetails: {},
  handleCancel: () => {},
  handleUpload: () => {},
  handleDelete: () => {},
  handleDeleteFile: () => {},
  toastSuccessMessage: '',
  toastErrorMessage: '',
  showToast: false,
  toastType: 'success',
};

UploadInvestmentProofsTemplate.propTypes = {
  formData: PropTypes.arrayOf,
  employeeDetails: PropTypes.shape({}),
  handleCancel: PropTypes.func,
  handleUpload: PropTypes.func,
  handleDelete: PropTypes.func,
  handleDeleteFile: PropTypes.func,
  toastSuccessMessage: PropTypes.string,
  toastErrorMessage: PropTypes.string,
  showToast: PropTypes.bool,
  toastType: PropTypes.oneOf(['error', 'success']),
};

export default UploadInvestmentProofsTemplate;
